import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=673e0546&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=673e0546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e0546",
  null
  
)

export default component.exports